import brandLogoImg from "../../images/BrandLogo.png";

/* -----------------------------------------------------------------------------
   The brand's logo.

   Two sources, in this order:

   1. `src` — what the brand uploaded on the S8MC Website Config screen, passed
      down from the BrandDetails response.
   2. The bundled images/BrandLogo.png, which is swapped per brand at build time.

   ⚠ The bundled file is NOT dead code and must stay. It is what every brand that
   has not opened the new screen is still using, and the build for a brand that
   has one is unchanged — removing it would blank the header for every existing
   site the moment this ships.

   ⚠ DO NOT ADD `width: 'auto'` OR `height: 'auto'` HERE. Both were added on the
   first pass and both are wrong: an uploaded SVG logo has an intrinsic RATIO but
   no intrinsic SIZE, and with `width:auto; height:auto` it resolves to 0×0 — the
   image loads, reports a naturalWidth, and renders at nothing. Caught by reading
   getBoundingClientRect in a browser; it is invisible in the code and invisible
   in a build. The max-height/max-width pair below is all the sizing this needs.

   The onError handler hides a broken logo rather than leaving a browser's
   broken-image icon in the header of a shop's website — a deleted file on the
   image host, or a host that is down.
   --------------------------------------------------------------------------- */
export default function BrandLogo(props) {
    const src = (props && props.src) ? props.src : brandLogoImg;

    /* The uploaded logo's real pixel size, when we know it. These are ATTRIBUTES,
       not CSS: they give the browser the aspect ratio so it reserves the right
       space before the file arrives and the header does not jump once it does.
       The max-height below still governs how big it actually draws. */
    const width = (props && props.width) ? props.width : undefined;
    const height = (props && props.height) ? props.height : undefined;

    return (<img src={src} alt="" width={width} height={height}
                 style={{maxHeight: "50px", maxWidth: "140px"}}
                 onError={(e) => e.target.style.display = 'none'}></img>)
}
